<template>
  <div>
    <JbRelation
      :biz-ctg="$config.BIZ_CATEGORY.PATROL"
      @link="linkToList"
    ></JbRelation>
  </div>
</template>

<script>
import JbRelation from '@/views/omp/cleaning/plan/components/JbRelation.vue'
export default {
  name: 'PatrolRelation',
  components: {
    JbRelation
  },
  computed: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    linkToList() {
      this.$tabs.close({ to: '/omp/patrol/plan/list' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
